import React from "react";
import "./Projects.css";
import zoomcar from "../imgss/zoomcar.jpg"
import times from "../imgss/times.png"
import video from './she.mp4'
import cs from './cs.jpeg'
import { FaReact, FaHardHat } from "react-icons/fa";
import VideoPlayer from './Videoplayer';
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">
        <div className="projects_container" data-aos="fade-right" >
        <div className="project" style={{paddingBottom:"39px"}}>
          <div className="project_videocontainer">
            <div>
            <video autoPlay muted controls src={video} style={{ maxWidth: '100%', height: 'auto' }} />
            </div>
          </div>
          <div className="project_information">
            <h2>SHEQONOMI Podcast App</h2>
            <p>
            The State of Women is the ‘voice’ and the platform that shares, connects, promotes, and works towards gender equity through conversation,
             connection, community, and creativity. SHEQONOMI is the ‘vessel’ that distributes that ‘voice’ and message around the world. 
            </p>
            <div>
           
              <IoLogoJavascript />
              <SiExpress />
              <SiMongodb />
              <SiNodedotjs />
              
            
              


            </div>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.sheqonomi2"
                target="_blank"
                rel="noreferrer"
              >
                <span type="button" className="btns onbt onbt">
                  See this Live
                </span>
              </a>
           
            </div>
          </div>
        </div>
      </div>
      <div className="projects_container" data-aos="fade-right">
      <div className="project">
        <div className="project_videocontainer">
          <div>
            
            <VideoPlayer videoId="E8heNNlwLd8" />
          </div>
        </div>
        <div className="project_information">
          <h2>Ad Yogi</h2>
          <p>
          As a Premier Google Partner & Facebook Agency Partner, our digital marketing specialists offer
           unmatched expertise in paid search for e-commerce companies, starting from campaign creation to final conversion optimization. Sit back and relax while we focus
           our energy on getting just the right set of people to visit your online store and make purchases, thereby scale your business in quite time.
          </p>
          <div>
            <DiCss3 />
            <SiHtml5 />
            <IoLogoJavascript />
            <SiExpress />
            <SiMongodb />
            <SiNodedotjs />
            <FaReact />
            <SiReactrouter />
            


          </div>
          <div>
            <a
              href="https://marketplace.adyogi.com/login"
              target="_blank"
              rel="noreferrer"
            >
              <span type="button" className="btns onbt onbt">
                See this Live
              </span>
            </a>
          
          </div>
        </div>
      </div>
    </div>
    <div className="projects_container" data-aos="fade-right">
    <div className="project" style={{paddingBottom:"68px"}}>
      <div className="project_videocontainer">
        <div>
          <img src={cs} alt="Rockstar Games" />
        </div>
      </div>
      <div className="project_information">
        <h2>Controlshift.in</h2>
        <p>
        We're a team of dedicated professionals who are passionate about helping businesses succeed. We take the time to get to know our
         clients and candidates on a personal level, and we're committed to building strong, lasting relationships that benefit everyone involved
        </p>
        <div>
          <DiCss3 />
          <SiHtml5 />
          <IoLogoJavascript />
          <SiExpress />
          <SiMongodb />
          <SiNodedotjs />
          <FaReact />
          <SiReactrouter />
          


        </div>
        <div>
          <a
            href="https://controlshift.in/"
            target="_blank"
            rel="noreferrer"
          >
            <span type="button" className="btns onbt onbt">
              See this Live
            </span>
          </a>
       
        </div>
      </div>
    </div>
  </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://camo.githubusercontent.com/4734a2617984e5b132cd1e6deb0f992321ec0eb43a7ba5dbed689d01d7ed035b/68747470733a2f2f6c68362e676f6f676c6575736572636f6e74656e742e636f6d2f756254336c56375744386738575f57474a4d3254385753372d6756696c6135396956727856436362463535653761392d6c6845385471686f353265675757586f745370424535644e575453666a414e71784b76686670505f755739333861734e57524677757672357764546d7377586d457173747a7944574b494c505662316d51556e3474494c4a" alt="Rockstar Games" />
                </div>
              </div>
              <div className="project_information">
                <h2>T-Metric.com</h2>
                <p>
                TMetric is time tracking software operated by TMetric team, headquartered in
Prague, Czech Republic, that offers time tracking service for freelancers and small
business owners who want to optimize their business processes and increase
personal productivity.
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <SiExpress />
                  <SiMongodb />
                  <SiNodedotjs />
                  <FaReact />
                  <SiReactrouter />
                  


                </div>
                <div>
                  <a
                    href="https://tmetric-clone.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/tmetric-clone"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://camo.githubusercontent.com/5d88184cc0bf3a6654a25f7b430cc40743c99a9682843fd71f63070d882d036f/68747470733a2f2f7777642e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032312f30342f416e7468726f706f6c6f6769652d77696e646f772e6a7067" alt="Sk-Weather-App" />
                </div>
              </div>
              <div className="project_information">
                <h2>Anthropology.com</h2>
                <p>
                 Anthropologie is a unique, full-lifestyle shopping destination, with a mostly exclusive assortment of clothing, shoes, accessories, beauty, furniture, home décor, garden, bridal, and more. I have tried my best to make a fully-functional clone of Pottery Barn website that provides a minimal user experience .
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                  <FaReact />
                  <SiReactrouter />
                </div>
                <div>
                  <a
                    href="https://anthropology-clone-gyan.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/anthropologie.com-clone"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="projects_container" data-aos="fade-right">
            <div className="project" style={{paddingBottom:"110px"}}>
              <div className="project_videocontainer">
                <div>
                  <img src="https://www.reviewsxp.com/blog/wp-content/uploads/2020/05/Pottery-Barn.jpg" alt="" />
                </div>
              </div>
              <div className="project_information">
                <h2>
Potery-Barn.com
</h2>
                <p>
                Our Team Project for construct week.This is a e-commerce,We have tried our best to make a fully-functional clone of Pottery Barn website that provides a minimal user experience where users can roam around and purchase their desired products.
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                </div>
                <div>
                  <a
                    href="https://ephemeral-liger-c209b7.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/Pottery-barn"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

         
              
          <div className="projects_container" data-aos="fade-right">
            <div className="project" style={{paddingBottom:"110px"}}>
              <div className="project_videocontainer">
                <div>
                  <img src={times} alt="Uniqlo-Clone" />
                </div>
              </div>
              <div className="project_information">
                <h2>Hindustan Times Clone</h2>
                <p>
                  Hindusthan times is a most famous online news website that 
                  gives news from all over the world. It is categorised into many section like national, international, Business,Bollywood,Defence,Industries etc.
                </p>
                <div>
                  <SiHtml5 />
                  <DiCss3 />
                  <IoLogoJavascript />
                  <FaReact />
                  <SiReactrouter />
                </div>
                <div>
                  <a
                    href="https://vocal-otter-b01c49.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/HindustanTimes_Clone"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>






          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://pbs.twimg.com/media/CiAIvglU4AA7pm_.jpg" alt="PulsePlus-Clone" />
                </div>
              </div>
              <div className="project_information">
                <h2>Spareshub-automobiles</h2>
                <p >
                it is automobiles marketplace,basically it is e-commerce website.A website that helps customers buy genuine spare parts of most of the cars in India. 
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                 
                </div>
                <div>
                  <a
                    href="https://spareshub-clone.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/spareshub-automobiles"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>



       



          {/* /////// */}
          <div className="projects_container" data-aos="fade-right">
            <div className="project" style={{paddingBottom:"39px"}}>
              <div className="project_videocontainer">
                <div>
                  <img src={zoomcar} alt="PulsePlus-Clone" />
                </div>
              </div>
              <div className="project_information">
                <h2>Stopwatch</h2>
                <p >
                 Stopwatch with accurate Stop watch Timer, where user set their Time according to their need and perform their operations.
                 
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <FaReact />
                  <SiReactrouter />
                </div>
                <div>
                  <a
                    href="https://gyan-googletimer-stopwatch.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/StopWatch-Timer"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* /// */}


          


          




          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://reactjsexample.com/content/images/2021/10/Screenshot--35-.png" alt="PulsePlus-Clone" />
                </div>
              </div>
              <div className="project_information">
                <h2>
TextChanger-App</h2>
                <p >
                t is a Text-Changer App where user can Edit their text like, Smaller to Capital ,Capital to Smaller,User also copy text,Remove extra Spaces.
                </p>
                <div>
                  <DiCss3 />
                  <SiHtml5 />
                  <IoLogoJavascript />
                  <FaReact />
                  <SiReactrouter />
                </div>
                <div>
                  <a
                    href="https://textchanger-gyancom.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/gyanimishra/TextChanger-App"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>




          





        </div>
      </div>
    </>
  );
};
